/* eslint-disable angular/factory-name */

angular.
module("digiexam.services").
factory("blob", function blob() {
	"use strict";

	function imageUploadUrl() {
		return "/blob/imageupload/";
	}

	return {
		imageUploadUrl: imageUploadUrl,
	};
});
